module.exports = __webpack_public_path__ + "img/SKMJ_enter3.5a94d325.png";